module.exports = __webpack_public_path__ + "img/socket.98613e6d.png";